<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

import CampaignLayout from 'dashboard/components-next/Campaigns/CampaignLayout.vue';
import { useCampaign } from 'dashboard/composables/useCampaign';
import OneOffCampaigns from './oneoff/Campaign.vue';
import OngoingCampaigns from './ongoing/Campaign.vue';
import AddOngoingCampaign from './ongoing/AddCampaign.vue';
import AddOneOffCampaign from './oneoff/AddCampaign.vue';

const store = useStore();
const { t } = useI18n();
const { isOngoingType } = useCampaign();

const showAddOneOffPopup = ref(false);
const showAddOngoingPopup = ref(false);

const buttonText = computed(() =>
  isOngoingType.value
    ? t('CAMPAIGN.HEADER_BTN_TXT.ONGOING')
    : t('CAMPAIGN.HEADER_BTN_TXT.ONE_OFF')
);

const headerTitle = computed(() =>
  isOngoingType.value
    ? t('CAMPAIGN.ONGOING.HEADER')
    : t('CAMPAIGN.ONE_OFF.HEADER')
);

const headerIcon = computed(() =>
  isOngoingType.value ? 'arrow-swap' : 'sound-source'
);

const openAddPopup = () => {
  if (isOngoingType.value) showAddOngoingPopup.value = true;
  else showAddOneOffPopup.value = true;
};

const hideAddPopup = () => {
  showAddOngoingPopup.value = false;
  showAddOneOffPopup.value = false;
};

onMounted(() => {
  store.dispatch('agentBots/get');
});
</script>

<template>
  <CampaignLayout
    :header-title="headerTitle"
    :button-label="buttonText"
    :icon="headerIcon"
    @click="openAddPopup"
  >
    <OngoingCampaigns v-if="isOngoingType" key="ongoing" />
    <OneOffCampaigns v-else key="oneoff" />

    <woot-modal
      v-if="showAddOngoingPopup"
      v-model:show="showAddOngoingPopup"
      :on-close="hideAddPopup"
    >
      <AddOngoingCampaign @on-close="hideAddPopup" />
    </woot-modal>

    <woot-modal
      v-if="showAddOneOffPopup"
      v-model:show="showAddOneOffPopup"
      :on-close="hideAddPopup"
    >
      <AddOneOffCampaign @on-close="hideAddPopup" />
    </woot-modal>
  </CampaignLayout>
</template>
